import ActivityIframePlanner from '../../../components/pages/ActivityIframePlanner';

export default ActivityIframePlanner;

// eslint-disable-next-line @typescript-eslint/require-await
export const getServerSideProps = async () => ({ props: {} });
